var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-list" },
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "search-container" },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.query },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户名称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请输入客户名称", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.crud.toQuery($event)
                          },
                        },
                        model: {
                          value: _vm.query.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "name", $$v)
                          },
                          expression: "query.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户ID" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          type: "number",
                          placeholder: "请输入客户ID",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.crud.toQuery($event)
                          },
                        },
                        model: {
                          value: _vm.query.custId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "custId", $$v)
                          },
                          expression: "query.custId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户地址" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请输入客户地址", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.crud.toQuery($event)
                          },
                        },
                        model: {
                          value: _vm.query.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "address", $$v)
                          },
                          expression: "query.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户电话" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请输入客户电话", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.crud.toQuery($event)
                          },
                        },
                        model: {
                          value: _vm.query.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "mobile", $$v)
                          },
                          expression: "query.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "合同号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请输入合同号", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.crud.toQuery($event)
                          },
                        },
                        model: {
                          value: _vm.query.contractNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "contractNo", $$v)
                          },
                          expression: "query.contractNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMoreSearch,
                            expression: "showMoreSearch",
                          },
                        ],
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "wrap",
                          width: "100%",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder: "请选择客户状态",
                                  clearable: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleQuickFilter(
                                      _vm.activeFilter
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.activeFilter,
                                  callback: function ($$v) {
                                    _vm.activeFilter = $$v
                                  },
                                  expression: "activeFilter",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" },
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.dict.customer_status_button,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "合同状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "全部", clearable: "" },
                                on: { change: _vm.searchCustomers },
                                model: {
                                  value: _vm.query.contractStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, "contractStatus", $$v)
                                  },
                                  expression: "query.contractStatus",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" },
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.dict.contract_status_button,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "审计" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "全部", clearable: "" },
                                on: { change: _vm.searchCustomers },
                                model: {
                                  value: _vm.query.isAudit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, "isAudit", $$v)
                                  },
                                  expression: "query.isAudit",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "待审计", value: 1 },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "已审计", value: 2 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "归档" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "全部", clearable: "" },
                                on: { change: _vm.searchCustomers },
                                model: {
                                  value: _vm.query.isArchive,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, "isArchive", $$v)
                                  },
                                  expression: "query.isArchive",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "是", value: 1 },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "否", value: 0 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "测未定" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "全部", clearable: "" },
                                on: { change: _vm.searchCustomers },
                                model: {
                                  value: _vm.query.unmeasured,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, "unmeasured", $$v)
                                  },
                                  expression: "query.unmeasured",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "是", value: "是" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "否", value: "否" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "门店" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "请输入门店名称",
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.crud.toQuery($event)
                                },
                              },
                              model: {
                                value: _vm.query.storeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "storeName", $$v)
                                },
                                expression: "query.storeName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "导购" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "请输入导购姓名",
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.crud.toQuery($event)
                                },
                              },
                              model: {
                                value: _vm.query.storeSellerNick,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "storeSellerNick", $$v)
                                },
                                expression: "query.storeSellerNick",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "设计师" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "请输入设计师姓名",
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.crud.toQuery($event)
                                },
                              },
                              model: {
                                value: _vm.query.sjName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "sjName", $$v)
                                },
                                expression: "query.sjName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "创建时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "240px" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                                clearable: "",
                              },
                              on: { change: _vm.searchCustomers },
                              model: {
                                value: _vm.createDateRange,
                                callback: function ($$v) {
                                  _vm.createDateRange = $$v
                                },
                                expression: "createDateRange",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "计划测量" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "240px" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                                clearable: "",
                              },
                              on: { change: _vm.searchCustomers },
                              model: {
                                value: _vm.planMeasureTimeRange,
                                callback: function ($$v) {
                                  _vm.planMeasureTimeRange = $$v
                                },
                                expression: "planMeasureTimeRange",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "签单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "240px" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                                clearable: "",
                              },
                              on: { change: _vm.searchCustomers },
                              model: {
                                value: _vm.contractTimeRange,
                                callback: function ($$v) {
                                  _vm.contractTimeRange = $$v
                                },
                                expression: "contractTimeRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "search-btn-item" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              _vm.showMoreSearch = !_vm.showMoreSearch
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.showMoreSearch ? "收起" : "展开") +
                              "\n            "
                          ),
                          _c("i", {
                            class: _vm.showMoreSearch
                              ? "el-icon-arrow-up"
                              : "el-icon-arrow-down",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.crud.loading },
                          on: { click: _vm.searchCustomers },
                        },
                        [
                          _c("i", { staticClass: "el-icon-search" }),
                          _vm._v(" 搜索\n          "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "divider-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "quick-filter" }, [
            _c(
              "div",
              { staticClass: "filter-tags-container" },
              [
                _c(
                  "div",
                  {
                    staticClass: "filter-tag",
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickFilter("")
                      },
                    },
                  },
                  [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.activeFilter === "" ? "primary" : "info",
                          effect: _vm.activeFilter === "" ? "dark" : "plain",
                        },
                      },
                      [_vm._v("\n          全部\n        ")]
                    ),
                    _vm._v(" "),
                    _vm.customerStatistics.total > 0
                      ? _c("span", { staticClass: "tag-badge" }, [
                          _vm._v(_vm._s(_vm.customerStatistics.total)),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.dict.customer_status_button, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "filter-tag",
                      on: {
                        click: function ($event) {
                          return _vm.handleQuickFilter(item.value)
                        },
                      },
                    },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              _vm.activeFilter === item.value
                                ? _vm.getTagType(item.value)
                                : "info",
                            effect:
                              _vm.activeFilter === item.value
                                ? "dark"
                                : "plain",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.label) + "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.getStatisticsCount(item.value) > 0
                        ? _c("span", { staticClass: "tag-badge" }, [
                            _vm._v(_vm._s(_vm.getStatisticsCount(item.value))),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "quick-filter-right" }, [
              _c(
                "div",
                { staticClass: "header-actions" },
                [
                  _c("el-button", { on: { click: _vm.handleCreateCustomer } }, [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v(" 新增客户\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        icon: _vm.allExpanded
                          ? "el-icon-arrow-up"
                          : "el-icon-arrow-down",
                      },
                      on: { click: _vm.toggleExpandAll },
                    },
                    [_vm._v(_vm._s(_vm.allExpanded ? "全部折叠" : "全部展开"))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "config-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-download",
                        loading: _vm.exportLoading,
                      },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v("导出")]
                  ),
                  _vm._v(" "),
                  _vm.checkPer(["admin", "customers:chart"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-s-data" },
                          on: { click: _vm.openOrderRateDialog },
                        },
                        [_vm._v("图表")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkPer(["admin", "customers:config"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-setting" },
                          on: { click: _vm.openConfigDialog },
                        },
                        [_vm._v("配置")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.crud.loading,
                  expression: "crud.loading",
                },
              ],
              attrs: {
                "element-loading-text": "正在加载客户数据...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255, 255, 255, 0.8)",
              },
            },
            [
              _c(
                "el-table",
                {
                  ref: "customerTable",
                  staticStyle: {
                    width: "100%",
                    "margin-bottom": "20px",
                    "font-size": "16px",
                  },
                  attrs: {
                    data: _vm.crud.data,
                    "max-height": _vm.tableHeight,
                    "header-cell-style": {
                      backgroundColor: "#e8eaed",
                      color: "#333",
                      fontWeight: "bold",
                    },
                    "cell-style": { paddingBottom: "6px", paddingTop: "6px" },
                    border: "",
                    "row-key": "id",
                  },
                  on: { "row-click": _vm.handleRowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.contracts &&
                            scope.row.contracts.length > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-left": "20px" } },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: {
                                          width: "calc(100% - 20px)",
                                          "font-size": "14px",
                                        },
                                        attrs: {
                                          data: scope.row.contracts,
                                          size: "small",
                                          "header-cell-style": {
                                            backgroundColor: "#e8eaed",
                                            color: "#333",
                                            fontWeight: "bold",
                                          },
                                          "cell-style": {
                                            backgroundColor: "#FFF",
                                          },
                                          border: "",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "操作",
                                            width: "360",
                                            fixed: "left",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contract:edit",
                                                    ]) &&
                                                    row.row.isArchive !== 1
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#606266",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleEditContract(
                                                                  row.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("编辑")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.checkPer([
                                                      "admin",
                                                      "order:add",
                                                    ])
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#606266",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleCreateOrder(
                                                                  row.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("下单")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contracts:specialApply",
                                                    ])
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#606266",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleSpecialApply(
                                                                  row.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("审批申请")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    row.row.isArchive === 0 &&
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contract:archive",
                                                    ])
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#409EFF",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleArchiveContract(
                                                                  row.row.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("归档")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    row.row.isArchive === 1 &&
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contract:archive",
                                                    ])
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#E6A23C",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleUnarchiveContract(
                                                                  row.row.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("取消归档")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    row.row.isAudit === 1 &&
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contract:audit",
                                                    ])
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#67C23A",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleAuditContract(
                                                                  row.row.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("审计")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    row.row.isAudit === 2 &&
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contract:audit",
                                                    ])
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#E6A23C",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleUnAuditContract(
                                                                  row.row.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("取消审计")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contract:del",
                                                    ]) &&
                                                    row.row.isArchive !== 1
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              color: "#F56C6C",
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleDeleteContract(
                                                                  row.row.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("删除")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contractNo",
                                            label: "合同号",
                                            "min-width": "180",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "contract-no-link",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.handleViewContract(
                                                              row.row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              row.row
                                                                .contractNo ||
                                                                "待填合同号"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    row.row.contractLevel ===
                                                      "主合同" &&
                                                    _vm.checkPer([
                                                      "admin",
                                                      "contracts:add",
                                                    ])
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#67C23A",
                                                              "font-size":
                                                                "12px",
                                                              "margin-left":
                                                                "5px",
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.handleAddSubcontract(
                                                                  row.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("+子合同")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contractLevel",
                                            label: "合同类型",
                                            "min-width": "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: [
                                                          "contract-level-tag",
                                                          {
                                                            "main-contract":
                                                              row.row
                                                                .contractLevel ===
                                                              "主合同",
                                                            "sub-contract":
                                                              row.row
                                                                .contractLevel ===
                                                              "子合同",
                                                          },
                                                        ],
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              row.row
                                                                .contractLevel ||
                                                                "-"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contractStatusEnumeration",
                                            label: "合同状态",
                                            "min-width": "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "isAudit",
                                            label: "审计状态",
                                            "min-width": "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.auditStatusMap[
                                                            row.row.isAudit
                                                          ]
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "auditTime",
                                            label: "审计时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "archiveTime",
                                            label: "归档时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "amount",
                                            label: "合同金额",
                                            "min-width": "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _vm._v(
                                                      "\n                    ¥" +
                                                        _vm._s(
                                                          (
                                                            row.row.amount || 0
                                                          ).toFixed(2)
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contactPerson",
                                            label: "客户名称",
                                            "min-width": "120",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contactNumber",
                                            label: "客户电话",
                                            "min-width": "120",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contactAddress",
                                            label: "客户地址",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "unmeasured",
                                            label: "测未定",
                                            "min-width": "80",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contractImgs",
                                            label: "图片",
                                            "min-width": "80",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    row.row.contractImgs
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "file-count",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.previewContractImgs(
                                                                  row.row
                                                                    .contractImgs
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.parseContractImgs(
                                                                    row.row
                                                                      .contractImgs
                                                                  ).length
                                                                ) +
                                                                " 张\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v("-"),
                                                        ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "file",
                                            label: "附件",
                                            "min-width": "80",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    row.row.file
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "file-count",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.previewContractFiles(
                                                                  row.row.file
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.parseContractFiles(
                                                                    row.row.file
                                                                  ).length
                                                                ) +
                                                                " 个\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v("-"),
                                                        ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "submitUser",
                                            label: "创建人",
                                            "min-width": "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "createdatetime",
                                            label: "创建时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "guideNickName",
                                            label: "导购",
                                            "min-width": "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.parseArrayField(
                                                            row.row
                                                              .guideNickName
                                                          ) || "-"
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "designerNickName",
                                            label: "设计师",
                                            "min-width": "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.parseArrayField(
                                                            row.row
                                                              .designerNickName
                                                          ) || "-"
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "orderClerkNickName",
                                            label: "下单员",
                                            "min-width": "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.parseArrayField(
                                                            row.row
                                                              .orderClerkNickName
                                                          ) || "-"
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "contractTime",
                                            label: "签单时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "orderClerkTime",
                                            label: "下单时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "measureTime",
                                            label: "测量时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "recoveryTime",
                                            label: "复尺时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "confirmPlanTime",
                                            label: "方案确认时间",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "agreedConstructionPeriod",
                                            label: "预约工期",
                                            "min-width": "120",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "scheduledDeliveryDate",
                                            label: "预定交期",
                                            "min-width": "120",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "positioning",
                                            label: "定位",
                                            "min-width": "180",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (row) {
                                                  return [
                                                    row.row.positioning
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "location-tag located",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.row
                                                                  .positioning
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "location-tag",
                                                          },
                                                          [_vm._v("未定位")]
                                                        ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#909399",
                                      "text-align": "center",
                                    },
                                  },
                                  [_vm._v("暂无合同")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.checkPer(["admin", "cust:edit"])
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#606266" },
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkPer(["admin", "contracts:add"])
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#606266" },
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleAddContract(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("新增合同")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.tableHeader, function (col) {
                    return _vm.isColumnVisible(col.key) &&
                      col.key !== "operation"
                      ? _c("el-table-column", {
                          key: col.key,
                          attrs: {
                            prop: col.key,
                            "min-width": _vm.getColumnWidth(col.key),
                            label: col.label,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.key === "custStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.getTagType(
                                                scope.row.custStatus
                                              ),
                                              size: "small",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  scope.row.custStatus || "未知"
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            class: _vm.getColumnClass(col.key),
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleColumnClick(
                                                  col.key,
                                                  scope.row,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.getColumnValue(
                                                    col.key,
                                                    scope.row
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e()
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.dialogTitle,
                visible: _vm.dialogVisible,
                width: "600px",
                "close-on-click-modal": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "customerForm",
                  attrs: {
                    model: _vm.customerForm,
                    rules: _vm.formRules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "客户姓名", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入客户姓名" },
                                model: {
                                  value: _vm.customerForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.customerForm, "name", $$v)
                                  },
                                  expression: "customerForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话", prop: "mobile" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入联系电话" },
                                model: {
                                  value: _vm.customerForm.mobile,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.customerForm, "mobile", $$v)
                                  },
                                  expression: "customerForm.mobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "客户来源", prop: "msgFrom" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择客户来源" },
                                  model: {
                                    value: _vm.customerForm.msgFrom,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.customerForm, "msgFrom", $$v)
                                    },
                                    expression: "customerForm.msgFrom",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "线上咨询",
                                      value: "线上咨询",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "线下展会",
                                      value: "线下展会",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "推荐", value: "推荐" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "线上广告",
                                      value: "线上广告",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "电话咨询",
                                      value: "电话咨询",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "带单人", prop: "inviter" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入带单人" },
                                model: {
                                  value: _vm.customerForm.inviter,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.customerForm, "inviter", $$v)
                                  },
                                  expression: "customerForm.inviter",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "客户微信", prop: "custWechat" },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入客户微信" },
                                model: {
                                  value: _vm.customerForm.custWechat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customerForm,
                                      "custWechat",
                                      $$v
                                    )
                                  },
                                  expression: "customerForm.custWechat",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否经销商区域",
                                prop: "isDistributor",
                                "label-width": "120px",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.customerForm.isDistributor,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customerForm,
                                        "isDistributor",
                                        $$v
                                      )
                                    },
                                    expression: "customerForm.isDistributor",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "是" } }, [
                                    _vm._v("是"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: "否" } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "所在地区", prop: "district" } },
                            [
                              _c("AddressCascader", {
                                on: {
                                  "region-change": _vm.handleRegionChange,
                                  "detail-change": _vm.handleDetailChange,
                                },
                                model: {
                                  value: _vm.customerForm.district,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.customerForm, "district", $$v)
                                  },
                                  expression: "customerForm.district",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "详细地址", prop: "address" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "如：那丰路1号 1栋301" },
                                model: {
                                  value: _vm.customerForm.address,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.customerForm, "address", $$v)
                                  },
                                  expression: "customerForm.address",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "最后联系", prop: "lastContact" },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择最后联系时间",
                                },
                                model: {
                                  value: _vm.customerForm.lastContact,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customerForm,
                                      "lastContact",
                                      $$v
                                    )
                                  },
                                  expression: "customerForm.lastContact",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "20px 0",
                        display: "flex",
                        "justify-content": "flex-end",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex", gap: "10px" } },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.dialogVisible = false
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSave },
                            },
                            [_vm._v("保存客户")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { margin: "20px 0" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-bottom": "10px",
                            padding: "10px",
                            "background-color": "#f5f7fa",
                            "border-radius": "5px",
                            cursor: "pointer",
                          },
                          on: { click: _vm.toggleContractTable },
                        },
                        [
                          _c(
                            "h4",
                            { staticStyle: { margin: "0", padding: "0" } },
                            [
                              _vm._v("合同管理 "),
                              _c("i", {
                                class: [
                                  "el-icon",
                                  {
                                    "el-icon-arrow-down": _vm.showContractTable,
                                    "el-icon-arrow-right":
                                      !_vm.showContractTable,
                                  },
                                ],
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showContractTable
                        ? _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.customerForm.contracts || [],
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  width: "300",
                                  fixed: "left",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.checkPer([
                                            "admin",
                                            "contracts:edit",
                                          ]) && scope.row.isArchive !== 1
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#606266",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleEditContract(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-edit",
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " 编辑\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.isArchive === 0 &&
                                          _vm.checkPer([
                                            "admin",
                                            "contract:archive",
                                          ])
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#409EFF",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleArchiveContract(
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("归档")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.isArchive === 1 &&
                                          _vm.checkPer([
                                            "admin",
                                            "contract:archive",
                                          ])
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#E6A23C",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleUnarchiveContract(
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("取消归档")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.isAudit === 0 &&
                                          _vm.checkPer([
                                            "admin",
                                            "contract:audit",
                                          ])
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#409EFF",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleAuditContract(
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("待审计")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.isAudit === 1 &&
                                          _vm.checkPer([
                                            "admin",
                                            "contract:audit",
                                          ])
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#67C23A",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleAuditContract(
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("已审计")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.isAudit === 2 &&
                                          _vm.checkPer([
                                            "admin",
                                            "contract:audit",
                                          ])
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#E6A23C",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleUnAuditContract(
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("取消审计")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.checkPer([
                                            "admin",
                                            "contract:del",
                                          ]) && scope.row.isArchive !== 1
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#F56C6C",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleDeleteContract(
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete",
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " 删除\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2493136621
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contractNo",
                                  label: "合同号",
                                  width: "200",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(scope.row.contractNo) +
                                              "\n              "
                                          ),
                                          scope.row.contractLevel ===
                                            "主合同" &&
                                          _vm.checkPer([
                                            "admin",
                                            "contracts:add",
                                          ])
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "8px",
                                                    color: "#67C23A",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleAddSubcontract(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                +子合同\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3525506984
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contractLevel",
                                  label: "合同类型",
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class: [
                                                "contract-level-tag",
                                                {
                                                  "main-contract":
                                                    scope.row.contractLevel ===
                                                    "主合同",
                                                  "sub-contract":
                                                    scope.row.contractLevel ===
                                                    "子合同",
                                                },
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    scope.row.contractLevel ||
                                                      "-"
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3076780227
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contractAmount",
                                  label: "合同金额",
                                  width: "120",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n              ¥" +
                                              _vm._s(
                                                (
                                                  scope.row.contractAmount || 0
                                                ).toFixed(2)
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3701530183
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "budgetAmount",
                                  label: "预算金额",
                                  width: "120",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n              ¥" +
                                              _vm._s(
                                                (
                                                  scope.row.budgetAmount || 0
                                                ).toFixed(2)
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1860882480
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contractImgs",
                                  label: "合同图片",
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.contractImgs
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "file-count",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.previewContractImgs(
                                                        scope.row.contractImgs
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.parseContractImgs(
                                                          scope.row.contractImgs
                                                        ).length
                                                      ) +
                                                      " 张\n              "
                                                  ),
                                                ]
                                              )
                                            : _c("span", [_vm._v("-")]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  546260171
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "file",
                                  label: "附件",
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.file
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "file-count",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.previewContractFiles(
                                                        scope.row.file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.parseContractFiles(
                                                          scope.row.file
                                                        ).length
                                                      ) +
                                                      " 个\n              "
                                                  ),
                                                ]
                                              )
                                            : _c("span", [_vm._v("-")]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  604869541
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contractStatusEnumeration",
                                  label: "状态",
                                  width: "120",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contactAddress",
                                  label: "地址",
                                  width: "200",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "signatureDate",
                                  label: "签字日期",
                                  width: "120",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "scheduledDeliveryDate",
                                  label: "预定交期",
                                  width: "120",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "agreedConstructionPeriod",
                                  label: "约定工期(天数)",
                                  width: "120",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "guideNickName",
                                  label: "导购",
                                  width: "120",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.parseArrayField(
                                                  scope.row.guideNickName
                                                ) || "-"
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2834364717
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "designerNickName",
                                  label: "设计师",
                                  width: "120",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.parseArrayField(
                                                  scope.row.designerNickName
                                                ) || "-"
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2314097970
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "orderClerkNickName",
                                  label: "跟单员",
                                  width: "120",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.parseArrayField(
                                                  scope.row.orderClerkNickName
                                                ) || "-"
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1293831306
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "createdatetime",
                                  label: "创建时间",
                                  width: "180",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "text-align": "left",
                            display: "flex",
                            gap: "10px",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: _vm.handleAddContractFromCustomerDialog,
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.showContractForm
                                      ? "隐藏合同"
                                      : "添加合同"
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showContractForm
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.resetContractForm },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-refresh",
                                    staticStyle: { "margin-right": "5px" },
                                  }),
                                  _vm._v(" 置空\n          "),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showContractForm
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                margin: "20px 0",
                                padding: "10px",
                                "background-color": "#f5f7fa",
                                "border-radius": "5px",
                              },
                            },
                            [
                              _c(
                                "h4",
                                { staticStyle: { margin: "0", padding: "0" } },
                                [_vm._v("合同信息")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              ref: "contractForm",
                              attrs: {
                                model: _vm.contractForm,
                                rules: _vm.contractRules,
                                "label-width": "100px",
                              },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 14 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: ["dealer:info"],
                                              expression: "['dealer:info']",
                                            },
                                          ],
                                          attrs: {
                                            label: "经销商",
                                            prop: "dealerCode",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                filterable: "",
                                                placeholder: "请选择经销商",
                                              },
                                              on: {
                                                change: _vm.handleDealerChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.contractForm.dealerCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.contractForm,
                                                    "dealerCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "contractForm.dealerCode",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dealerList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.code || item.name,
                                                  attrs: {
                                                    label: item.name,
                                                    value:
                                                      item.code || item.name,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-col", { attrs: { span: 10 } }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 14 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "门店",
                                            prop: "dealerShopCode",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                filterable: "",
                                                placeholder: "请选择门店",
                                              },
                                              on: {
                                                change:
                                                  _vm.handleDealerShopChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.contractForm
                                                    .dealerShopCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.contractForm,
                                                    "dealerShopCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "contractForm.dealerShopCode",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dealerShopList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.shopNo,
                                                  attrs: {
                                                    label: item.shopName,
                                                    value: item.shopNo,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 10 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "是否测未定" } },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: "请选择",
                                                disabled:
                                                  !!_vm.editingContractId,
                                              },
                                              on: {
                                                change:
                                                  _vm.handleUnmeasuredChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.contractForm.unmeasured,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.contractForm,
                                                    "unmeasured",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "contractForm.unmeasured",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "是",
                                                  value: "是",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "否",
                                                  value: "否",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 14 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "合同号",
                                            prop: "contractNo",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              attrs: {
                                                placeholder: "请输入合同号",
                                              },
                                              on: {
                                                input:
                                                  _vm.handleContractNoChange,
                                              },
                                              model: {
                                                value:
                                                  _vm.contractForm.contractNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.contractForm,
                                                    "contractNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "contractForm.contractNo",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#fff",
                                                  },
                                                  attrs: {
                                                    slot: "append",
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.generateContractNo,
                                                  },
                                                  slot: "append",
                                                },
                                                [_vm._v("生成")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 10 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "合同类型",
                                            prop: "type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                filterable: "",
                                                placeholder: "请选择合同类型",
                                                disabled:
                                                  !!_vm.editingContractId,
                                              },
                                              model: {
                                                value: _vm.contractForm.type,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.contractForm,
                                                    "type",
                                                    $$v
                                                  )
                                                },
                                                expression: "contractForm.type",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dict.contract_type,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "客户姓名",
                                            prop: "customerName",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入客户姓名",
                                            },
                                            model: {
                                              value:
                                                _vm.contractForm.customerName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contractForm,
                                                  "customerName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contractForm.customerName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "客户电话",
                                            prop: "customerPhone",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入客户电话",
                                            },
                                            model: {
                                              value:
                                                _vm.contractForm.customerPhone,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contractForm,
                                                  "customerPhone",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contractForm.customerPhone",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "合同金额",
                                            prop: "contractAmount",
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "100%" },
                                            attrs: { min: 0, precision: 2 },
                                            model: {
                                              value:
                                                _vm.contractForm.contractAmount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contractForm,
                                                  "contractAmount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contractForm.contractAmount",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "预算金额",
                                            prop: "budgetAmount",
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "100%" },
                                            attrs: { min: 0, precision: 2 },
                                            model: {
                                              value:
                                                _vm.contractForm.budgetAmount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contractForm,
                                                  "budgetAmount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contractForm.budgetAmount",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "地址",
                                            prop: "address",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入地址信息",
                                            },
                                            model: {
                                              value: _vm.contractForm.address,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.contractForm,
                                                  "address",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "contractForm.address",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "合同图片" } },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("CommonUpload", {
                                                ref: "contractImgUpload",
                                                on: {
                                                  uploadSuccess:
                                                    _vm.uploadContractImgs,
                                                  delSuccess:
                                                    _vm.delContractImg,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.contractForm.contractImgs &&
                                          _vm.safeJsonParse(
                                            _vm.contractForm.contractImgs
                                          ).length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "demo-image__preview",
                                                },
                                                _vm._l(
                                                  _vm.safeJsonParse(
                                                    _vm.contractForm
                                                      .contractImgs
                                                  ),
                                                  function (img, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticStyle: {
                                                          float: "left",
                                                          "margin-right":
                                                            "10px",
                                                          "text-align":
                                                            "center",
                                                          position: "relative",
                                                        },
                                                      },
                                                      [
                                                        _c("el-image", {
                                                          staticStyle: {
                                                            height: "147px",
                                                            width: "147px",
                                                            "border-radius":
                                                              "5px",
                                                          },
                                                          attrs: {
                                                            src:
                                                              _vm.$store.getters
                                                                .imgPreviewPrefix +
                                                              img.realName,
                                                            "preview-src-list":
                                                              _vm.contractImgUrl(
                                                                _vm.contractForm
                                                                  .contractImgs
                                                              ),
                                                            fit: "contain",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "el-upload-list__item-delete",
                                                            staticStyle: {
                                                              position:
                                                                "absolute",
                                                              top: "20px",
                                                              right: "0",
                                                              "z-index": "9999",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.delContractImgByIndex(
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-delete",
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "附件" } },
                                        [
                                          _c("oss-upload", {
                                            ref: "contractFileUpload",
                                            attrs: {
                                              "upload-type": "file",
                                              multiple: true,
                                              accept:
                                                ".pdf,.zip,.rar,.7z,.doc,.docx,.xls,.xlsx",
                                              "oss-dir": "crm/contract/file/",
                                            },
                                            on: {
                                              "upload-success":
                                                _vm.uploadContractFiles,
                                              "delete-success":
                                                _vm.delContractFile,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.contractForm.file &&
                                          _vm.contractFileUrl(
                                            _vm.contractForm.file
                                          ).length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "demo-image__preview",
                                                },
                                                _vm._l(
                                                  _vm.safeJsonParse(
                                                    _vm.contractForm.file
                                                  ),
                                                  function (file, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticStyle: {
                                                          float: "left",
                                                          "margin-right":
                                                            "10px",
                                                          "text-align":
                                                            "center",
                                                          position: "relative",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "margin-top":
                                                                "20px",
                                                              height: "147px",
                                                              width: "147px",
                                                              "border-radius":
                                                                "5px",
                                                              "background-color":
                                                                "#f5f7fa",
                                                              display: "flex",
                                                              "align-items":
                                                                "center",
                                                              "justify-content":
                                                                "center",
                                                              border:
                                                                "1px solid #ebeef5",
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.openFileInNewWindow(
                                                                  file.url,
                                                                  file.realName
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "center",
                                                                  padding:
                                                                    "10px",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-document",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "48px",
                                                                    color:
                                                                      "#909399",
                                                                    "margin-bottom":
                                                                      "10px",
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "word-break":
                                                                          "break-all",
                                                                        "max-width":
                                                                          "120px",
                                                                        "font-size":
                                                                          "12px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        file.alias ||
                                                                          file.realName
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "el-upload-list__item-delete",
                                                            staticStyle: {
                                                              position:
                                                                "absolute",
                                                              top: "20px",
                                                              right: "0",
                                                              "z-index": "9999",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.delContractFileByIndex(
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-delete",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                {
                                  staticStyle: {
                                    "margin-top": "20px",
                                    "text-align": "right",
                                  },
                                  attrs: { gutter: 20 },
                                },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: _vm.saveContractFromDialog,
                                          },
                                        },
                                        [_vm._v("保存合同")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.editingContractId ? "编辑合同" : "新增合同",
                visible: _vm.showContractEditDialog,
                width: "600px",
                "close-on-click-modal": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showContractEditDialog = $event
                },
                close: _vm.cancelContractEditDialog,
              },
            },
            [
              _c(
                "div",
                { staticClass: "contract-form-section" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "contractForm",
                      attrs: {
                        model: _vm.contractForm,
                        rules: _vm.contractRules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 14 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: ["dealer:info"],
                                      expression: "['dealer:info']",
                                    },
                                  ],
                                  attrs: {
                                    label: "经销商",
                                    prop: "dealerCode",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择经销商",
                                      },
                                      on: { change: _vm.handleDealerChange },
                                      model: {
                                        value: _vm.contractForm.dealerCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contractForm,
                                            "dealerCode",
                                            $$v
                                          )
                                        },
                                        expression: "contractForm.dealerCode",
                                      },
                                    },
                                    _vm._l(_vm.dealerList, function (item) {
                                      return _c("el-option", {
                                        key: item.code || item.name,
                                        attrs: {
                                          label: item.name,
                                          value: item.code || item.name,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 10 } }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 14 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "门店",
                                    prop: "dealerShopCode",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择门店",
                                      },
                                      on: {
                                        change: _vm.handleDealerShopChange,
                                      },
                                      model: {
                                        value: _vm.contractForm.dealerShopCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contractForm,
                                            "dealerShopCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "contractForm.dealerShopCode",
                                      },
                                    },
                                    _vm._l(_vm.dealerShopList, function (item) {
                                      return _c("el-option", {
                                        key: item.shopNo,
                                        attrs: {
                                          label: item.shopName,
                                          value: item.shopNo,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "是否测未定" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: "请选择" },
                                      on: {
                                        change: _vm.handleUnmeasuredChange,
                                      },
                                      model: {
                                        value: _vm.contractForm.unmeasured,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contractForm,
                                            "unmeasured",
                                            $$v
                                          )
                                        },
                                        expression: "contractForm.unmeasured",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "是", value: "是" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "否", value: "否" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 14 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "合同号",
                                    prop: "contractNo",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: { placeholder: "请输入合同号" },
                                      on: { input: _vm.handleContractNoChange },
                                      model: {
                                        value: _vm.contractForm.contractNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contractForm,
                                            "contractNo",
                                            $$v
                                          )
                                        },
                                        expression: "contractForm.contractNo",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#fff" },
                                          attrs: {
                                            slot: "append",
                                            type: "primary",
                                          },
                                          on: { click: _vm.generateContractNo },
                                          slot: "append",
                                        },
                                        [_vm._v("生成")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "合同类型", prop: "type" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        placeholder: "请选择合同类型",
                                      },
                                      model: {
                                        value: _vm.contractForm.type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contractForm,
                                            "type",
                                            $$v
                                          )
                                        },
                                        expression: "contractForm.type",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dict.contract_type,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "客户姓名",
                                    prop: "customerName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入客户姓名" },
                                    model: {
                                      value: _vm.contractForm.customerName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contractForm,
                                          "customerName",
                                          $$v
                                        )
                                      },
                                      expression: "contractForm.customerName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "客户电话",
                                    prop: "customerPhone",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入客户电话" },
                                    model: {
                                      value: _vm.contractForm.customerPhone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contractForm,
                                          "customerPhone",
                                          $$v
                                        )
                                      },
                                      expression: "contractForm.customerPhone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "合同金额",
                                    prop: "contractAmount",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: { min: 0, precision: 2 },
                                    model: {
                                      value: _vm.contractForm.contractAmount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contractForm,
                                          "contractAmount",
                                          $$v
                                        )
                                      },
                                      expression: "contractForm.contractAmount",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "预算金额",
                                    prop: "budgetAmount",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: { min: 0, precision: 2 },
                                    model: {
                                      value: _vm.contractForm.budgetAmount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contractForm,
                                          "budgetAmount",
                                          $$v
                                        )
                                      },
                                      expression: "contractForm.budgetAmount",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "客户地址", prop: "address" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入客户地址" },
                                    model: {
                                      value: _vm.contractForm.address,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contractForm,
                                          "address",
                                          $$v
                                        )
                                      },
                                      expression: "contractForm.address",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "合同图片" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("CommonUpload", {
                                        ref: "contractImgUpload",
                                        on: {
                                          uploadSuccess: _vm.uploadContractImgs,
                                          delSuccess: _vm.delContractImg,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.contractForm.contractImgs &&
                                  _vm.safeJsonParse(
                                    _vm.contractForm.contractImgs
                                  ).length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "demo-image__preview" },
                                        _vm._l(
                                          _vm.safeJsonParse(
                                            _vm.contractForm.contractImgs
                                          ),
                                          function (img, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  float: "left",
                                                  "margin-right": "10px",
                                                  "text-align": "center",
                                                  position: "relative",
                                                },
                                              },
                                              [
                                                _c("el-image", {
                                                  staticStyle: {
                                                    height: "147px",
                                                    width: "147px",
                                                    "border-radius": "5px",
                                                  },
                                                  attrs: {
                                                    src:
                                                      _vm.$store.getters
                                                        .imgPreviewPrefix +
                                                      img.realName,
                                                    "preview-src-list":
                                                      _vm.contractImgUrl(
                                                        _vm.contractForm
                                                          .contractImgs
                                                      ),
                                                    fit: "contain",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    staticStyle: {
                                                      position: "absolute",
                                                      top: "20px",
                                                      right: "0",
                                                      "z-index": "9999",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.delContractImgByIndex(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "附件" } },
                                [
                                  _c("oss-upload", {
                                    ref: "contractFileUpload",
                                    attrs: {
                                      "upload-type": "file",
                                      multiple: true,
                                      accept:
                                        ".pdf,.zip,.rar,.7z,.doc,.docx,.xls,.xlsx",
                                      "oss-dir": "crm/contract/file/",
                                    },
                                    on: {
                                      "upload-success": _vm.uploadContractFiles,
                                      "delete-success": _vm.delContractFile,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.contractForm.file &&
                                  _vm.contractFileUrl(_vm.contractForm.file)
                                    .length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "demo-image__preview" },
                                        _vm._l(
                                          _vm.safeJsonParse(
                                            _vm.contractForm.file
                                          ),
                                          function (file, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  float: "left",
                                                  "margin-right": "10px",
                                                  "text-align": "center",
                                                  position: "relative",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "20px",
                                                      height: "147px",
                                                      width: "147px",
                                                      "border-radius": "5px",
                                                      "background-color":
                                                        "#f5f7fa",
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "center",
                                                      border:
                                                        "1px solid #ebeef5",
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.openFileInNewWindow(
                                                          file.url,
                                                          file.realName
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "text-align":
                                                            "center",
                                                          padding: "10px",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-document",
                                                          staticStyle: {
                                                            "font-size": "48px",
                                                            color: "#909399",
                                                            "margin-bottom":
                                                              "10px",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "word-break":
                                                                "break-all",
                                                              "max-width":
                                                                "120px",
                                                              "font-size":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                file.alias ||
                                                                  file.realName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    staticStyle: {
                                                      position: "absolute",
                                                      top: "20px",
                                                      right: "0",
                                                      "z-index": "9999",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.delContractFileByIndex(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    { on: { click: _vm.cancelContractEditDialog } },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveContractFromDialog },
                    },
                    [_vm._v("保存合同")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "客户信息",
                visible: _vm.followDialogVisible,
                width: "85%",
                "close-on-click-modal": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.followDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-card",
                { staticClass: "follow-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "customer-info-top",
                      staticStyle: {
                        "margin-bottom": "20px",
                        padding: "15px",
                        "background-color": "#f5f7fa",
                        "border-radius": "5px",
                      },
                    },
                    [
                      _c("base-info", {
                        ref: "baseInfo",
                        attrs: { "cust-id": _vm.currentCustomer.id },
                        on: { "data-change": _vm.handleBaseInfoChange },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeFollowTab,
                        callback: function ($$v) {
                          _vm.activeFollowTab = $$v
                        },
                        expression: "activeFollowTab",
                      },
                    },
                    [
                      _vm.checkPer(["admin", "customers:view"])
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "客户基本情况",
                                name: "basicInfo",
                              },
                            },
                            [
                              _c("basic-info", {
                                ref: "basicInfo",
                                attrs: {
                                  "cust-id": _vm.currentCustomer.id,
                                  "basic-info": _vm.currentCustomer,
                                },
                                on: {
                                  "data-change": _vm.handleBasicInfoChange,
                                  "preview-img": _vm.handleBudgetImgPreview,
                                  "update-current-customer":
                                    _vm.handleUpdateCurrentCustomer,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "customers:requirements"])
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "客户需求",
                                name: "requirements",
                              },
                            },
                            [
                              _c("requirements", {
                                ref: "requirements",
                                attrs: {
                                  "cust-id": _vm.currentCustomer.id,
                                  "follow-info": _vm.currentCustomer.followInfo,
                                },
                                on: { save: _vm.handleRequirementsSave },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "customers:store"])
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "门店信息", name: "storeInfo" } },
                            [
                              _c("store-into", {
                                ref: "storeInfo",
                                attrs: {
                                  "cust-id": _vm.currentCustomer.id,
                                  "store-into": _vm.currentCustomer.storeInto,
                                },
                                on: {
                                  "update:storeInto": function ($event) {
                                    return _vm.$set(
                                      _vm.currentCustomer,
                                      "storeInto",
                                      $event
                                    )
                                  },
                                  "update:store-into": function ($event) {
                                    return _vm.$set(
                                      _vm.currentCustomer,
                                      "storeInto",
                                      $event
                                    )
                                  },
                                  "refresh-store-data":
                                    _vm.handleRefreshStoreData,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "customers:follow"])
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "跟进", name: "followInfo" } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "follow-card-inner",
                                  attrs: { shadow: "never" },
                                },
                                [
                                  _c("follow-info", {
                                    ref: "followInfo",
                                    attrs: {
                                      "cust-id": _vm.currentCustomer.id,
                                      "follow-cust-service":
                                        _vm.currentCustomer.zxName || "",
                                      "cust-allot-user":
                                        _vm.currentCustomer.zdName || "",
                                    },
                                    on: {
                                      "preview-img": _vm.handleFollowImgPreview,
                                      "remove-img": _vm.handleFollowImgRemove,
                                      save: _vm.handleFollowSave,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.followImgDialogVisible,
                title: "图片预览",
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.followImgDialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  src: _vm.previewImgUrl,
                  alt: "预览图片",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.previewVisible,
                title: "合同图片预览",
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.previewVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                _vm._l(_vm.previewImages, function (img, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        width: "33.33%",
                        padding: "8px",
                        "box-sizing": "border-box",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            overflow: "auto",
                            display: "inline-block",
                            "max-width": "100%",
                          },
                        },
                        [
                          _c("el-image", {
                            staticStyle: { width: "100%", height: "280px" },
                            attrs: {
                              src: img.url,
                              alt: img.name,
                              "preview-src-list": _vm.previewImages.map(
                                function (i) {
                                  return i.url
                                }
                              ),
                              "initial-index": index,
                              fit: "contain",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center",
                            gap: "8px",
                            "margin-top": "6px",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                icon: "el-icon-download",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDownload(img)
                                },
                              },
                            },
                            [_vm._v("下载")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.previewFilesVisible,
                title: "合同附件预览",
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.previewFilesVisible = $event
                },
              },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.previewFiles },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "文件名", width: "300" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openFileInNewWindow(
                                      scope.row.url,
                                      scope.row.realName
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.name))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "url", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openFileInNewWindow(
                                      scope.row.url,
                                      scope.row.realName
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n            打开\n          ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  icon: "el-icon-download",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleFileDownload(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            下载  \n          ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "合同详情",
                visible: _vm.showContractViewDialog,
                width: _vm.dialogWidth,
                top: "20px",
                "close-on-click-modal": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showContractViewDialog = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contract-basic-info" },
                [
                  _c("ContractBasicInfo", {
                    attrs: {
                      contract: _vm.currentContract,
                      editable: _vm.contractEditable,
                    },
                    on: { "preview-image": _vm.previewImage },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "contract-view-section" },
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeContractTab,
                        callback: function ($$v) {
                          _vm.activeContractTab = $$v
                        },
                        expression: "activeContractTab",
                      },
                    },
                    [
                      _vm.checkPer(["admin", "contracts:design"])
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "设计信息", name: "design" } },
                            [
                              _c("ContractDesignInfo", {
                                ref: "contractDesignInfo",
                                attrs: {
                                  contract: _vm.currentContract,
                                  editable: _vm.contractEditable,
                                },
                                on: {
                                  "data-change":
                                    _vm.handleContractDesignInfoChange,
                                  "refresh-customer-data":
                                    _vm.refreshCustomerData,
                                  "refresh-contract-data":
                                    _vm.handleRefreshContractData,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "contracts:follow"])
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "跟进信息", name: "follow" } },
                            [
                              _c("ContractFollowInfo", {
                                attrs: {
                                  contract: _vm.currentContract,
                                  editable: _vm.contractEditable,
                                },
                                on: {
                                  "refresh-customer-data":
                                    _vm.refreshCustomerData,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "contracts:specialApply"])
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "审批申请", name: "special" } },
                            [
                              _c("ContractSpecialApply", {
                                ref: "specialApply",
                                attrs: {
                                  contract: _vm.currentContract,
                                  editable: _vm.contractEditable,
                                },
                                on: {
                                  "refresh-customer-data":
                                    _vm.refreshCustomerData,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "contracts:quotation"])
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "报价信息", name: "quotation" } },
                            [
                              _c("ContractQuotationInfo", {
                                ref: "contractQuotationInfo",
                                attrs: {
                                  contract: _vm.currentContract,
                                  editable: _vm.contractEditable,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "contracts:productionTracking"])
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "生产跟踪",
                                name: "productionTracking",
                              },
                            },
                            [
                              _c("ContractProductionTracking", {
                                ref: "contractProductionTracking",
                                attrs: {
                                  contract: _vm.currentContract,
                                  editable: _vm.contractEditable,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkPer(["admin", "contracts:view"])
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "改补描述", name: "afterInfo" } },
                            [
                              _c("ContractAfterInfo", {
                                ref: "contractAfterInfo",
                                attrs: {
                                  contract: _vm.currentContract,
                                  editable: _vm.contractEditable,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "图片预览",
                visible: _vm.previewImageVisible,
                width: "800px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.previewImageVisible = $event
                },
              },
            },
            [
              _c("img", {
                staticClass: "full-image",
                attrs: { src: _vm.previewImageUrl },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "客户表头配置",
                visible: _vm.configDialogVisible,
                width: "600px",
                "close-on-click-modal": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.configDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    height: "300px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "1",
                        "margin-right": "20px",
                        border: "1px solid #ebeef5",
                        "border-radius": "4px",
                        padding: "10px",
                      },
                    },
                    [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            margin: "0 0 10px 0",
                            "font-size": "14px",
                            "font-weight": "bold",
                          },
                        },
                        [_vm._v("可选列")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "calc(100% - 30px)",
                            "overflow-y": "auto",
                          },
                        },
                        [
                          _vm._l(_vm.tableHeader, function (col, index) {
                            return !_vm.isColumnVisible(col.key)
                              ? _c(
                                  "div",
                                  {
                                    key: col.key,
                                    staticStyle: {
                                      padding: "8px",
                                      "margin-bottom": "8px",
                                      "background-color": "#fff",
                                      border: "1px solid #ebeef5",
                                      "border-radius": "4px",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleColumnVisible(col.key)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(col.label) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          !_vm.tableHeader.some(function (col) {
                            return !_vm.isColumnVisible(col.key)
                          })
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#909399",
                                    padding: "20px",
                                  },
                                },
                                [_vm._v("\n            暂无可选列\n          ")]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "justify-content": "center",
                        gap: "10px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-arrow-right",
                            disabled: !_vm.tableHeader.some(function (col) {
                              return !_vm.isColumnVisible(col.key)
                            }),
                          },
                          on: { click: _vm.moveAllToRight },
                        },
                        [_vm._v("全部右移")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-arrow-left",
                            disabled: !_vm.tableHeader.some(function (col) {
                              return _vm.isColumnVisible(col.key)
                            }),
                          },
                          on: { click: _vm.moveAllToLeft },
                        },
                        [_vm._v("全部左移")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "1",
                        "margin-left": "20px",
                        border: "1px solid #ebeef5",
                        "border-radius": "4px",
                        padding: "10px",
                      },
                    },
                    [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            margin: "0 0 10px 0",
                            "font-size": "14px",
                            "font-weight": "bold",
                          },
                        },
                        [
                          _vm._v("已选列（"),
                          _c("i", {
                            staticClass: "el-icon-rank",
                            staticStyle: { "margin-right": "5px" },
                          }),
                          _vm._v("拖拽排序）"),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "calc(100% - 30px)",
                            "overflow-y": "auto",
                          },
                          attrs: { id: "selectedColumnsList" },
                        },
                        [
                          _c(
                            "draggable",
                            {
                              staticStyle: { "min-height": "100%" },
                              attrs: {
                                options: {
                                  animation: 150,
                                  ghostClass: "sortable-ghost",
                                  handle: ".drag-handle",
                                },
                                element: "div",
                              },
                              model: {
                                value: _vm.visibleColumns,
                                callback: function ($$v) {
                                  _vm.visibleColumns = $$v
                                },
                                expression: "visibleColumns",
                              },
                            },
                            _vm._l(
                              _vm.visibleColumns,
                              function (col, visibleIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: col.key,
                                    staticStyle: {
                                      padding: "8px",
                                      "margin-bottom": "8px",
                                      "background-color": "#f5f7fa",
                                      "border-radius": "4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleColumnVisible(
                                                  col.key
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(col.label))]
                                        ),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-rank drag-handle",
                                          staticStyle: {
                                            cursor: "move",
                                            color: "#909399",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _vm.visibleColumns.length === 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    color: "#909399",
                                    padding: "20px",
                                  },
                                },
                                [_vm._v("\n            暂无已选列\n          ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.resetHeaderConfig } }, [
                    _vm._v("重置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHeaderConfig },
                    },
                    [_vm._v("保存配置")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("OrderRateChart", {
            attrs: { dialogVisible: _vm.orderRateDialogVisible },
            on: {
              "update:dialogVisible": function ($event) {
                _vm.orderRateDialogVisible = $event
              },
              "update:dialog-visible": function ($event) {
                _vm.orderRateDialogVisible = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }